import { __decorate } from "tslib";
import { getPassConfig, updatePassConfig } from '@blade-sxp/pass/api/access-management/device-management';
import { Component, Vue } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    deviceId = '';
    dataSource = {};
    taskList = [];
    taskDeletedList = [];
    passEditStatus = false;
    taskId = '';
    form = {
        direction: 'NONE',
        faceMatchThreshold: undefined,
        livenessThreshold: undefined,
        liveness: true,
        deviceRunType: 1,
        useMode: 1,
        mode: 1,
        welcomeTip: '',
        verifySuccessTip: '',
        verifyFaultTip: '',
        showUserInfo: '',
        faceWidth: undefined,
        openDoorType: 0,
        keepDoorOpenDuration: undefined,
        gpioA: 0,
        gpioB: 0,
        gpioC: 0,
        gpioD: 0,
        gpioE: 0,
        gpioF: 0,
        wiganInput: 1,
        buzzerStatus: false,
        languageType: 1,
        autoReboot: false,
        rebootTime: '',
        standbyOpen: false,
        waitTime: undefined,
        recognitionDistance: undefined,
        networkRelayAddress: '',
        openInterval: undefined,
        useShowAvatar: false,
        blackListTip: '',
        blackListOpen: false,
        certificateThreshold: undefined,
        showUserName: false,
        mshortExposure: undefined,
        mscreenBrightness: undefined,
        msoundVolume: undefined,
        mmaskDetect: false,
        mnoAccessWithoutMask: false,
    };
    data() {
        return {
            faceMatchThreshold: undefined,
            livenessThreshold: undefined,
        };
    }
    handleEdit() {
        this.passEditStatus = true;
    }
    handleCancel() {
        this.passEditStatus = false;
    }
    handleDeleteTask(task) {
        const { taskId } = task;
        this.taskList.splice(this.taskList.indexOf(task), 1);
        this.taskDeletedList.push(taskId);
    }
    handleGotoPassRecords() {
        this.$router.push({ path: '/traffic/record/comparisonRecord', query: { deviceId: this.deviceId } });
    }
    handleGotoDetail() {
        if (this.taskId) {
            this.$router.push({
                path: '/traffic/device/syncDetail',
                query: { taskId: this.taskId, deviceId: this.deviceId },
            });
        }
        else {
            console.warn('/traffic/device/syncDetail: taskId is null');
        }
    }
    handleSync() {
        this.passEditStatus = false;
        const form = this.form;
        const data = {
            ...form,
            deviceId: this.deviceId,
            // @ts-ignore
            faceMatchThreshold: form.faceMatchThreshold ? form.faceMatchThreshold / 100 : form.faceMatchThreshold,
            // @ts-ignore
            livenessThreshold: form.livenessThreshold ? form.livenessThreshold / 100 : form.livenessThreshold,
            // @ts-ignore
            certificateThreshold: form.certificateThreshold ? form.certificateThreshold / 100 : form.certificateThreshold,
            passTaskIdList: this.taskDeletedList,
        };
        updatePassConfig(this.deviceId, data).then(resp => {
            this.taskId = resp?.data?.data?.lastTaskId || '';
            this.$message.success(resp?.data?.message || `${this.$t('common.success')}`);
            this.taskDeletedList = [];
            // if (this.taskId) { this.handleGotoDetail(); }
        }).catch(error => {
            this.$message({ type: 'error', message: error });
        });
    }
    getData() {
        if (!this.deviceId)
            return;
        getPassConfig(this.deviceId).then(resp => {
            this.dataSource = resp?.data?.data || undefined;
            const { taskList = [], ...rest } = this.dataSource || {};
            this.taskList = [...taskList];
            this.taskId = this.dataSource?.lastTaskId || '';
            this.form = { ...rest };
            const faceMatchThreshold = this.dataSource?.faceMatchThreshold ?? undefined;
            this.form.faceMatchThreshold = faceMatchThreshold ? faceMatchThreshold * 100 : faceMatchThreshold;
            const livenessThreshold = this.dataSource?.livenessThreshold ?? undefined;
            this.form.livenessThreshold = livenessThreshold ? livenessThreshold * 100 : livenessThreshold;
        }).catch(error => {
            this.$message({ type: 'error', message: error });
        });
    }
    mounted() {
        const query = this.$route.query;
        this.deviceId = query.deviceId;
        this.getData();
    }
};
default_1 = __decorate([
    Component({
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    son: 'Sub-device Name/Sub-device ID',
                    pleaseSelect: 'Please select',
                    pleaseInput: 'Please input',
                    none: 'None',
                    in: 'In',
                    out: 'Out',
                    open: 'Open',
                    close: 'Close',
                    deviceError: 'Pass task error',
                    deviceRunType: 'Device Run Type',
                    useMode: 'Use Mode',
                    mode: 'Check Mode',
                    welcomeTip: 'welcome tip',
                    verifySuccessTip: 'Verify Success Tip',
                    verifyFaultTip: 'Verify Fault Tip',
                    showUserInfo: 'Show User Info',
                    faceWidth: 'Face Width',
                    openDoorType: 'Open Door Type',
                    keepDoorOpenDuration: 'Door Open Duration',
                    gpioA: 'Gpio A',
                    gpioB: 'Gpio B',
                    gpioC: 'Gpio C',
                    gpioD: 'Gpio D',
                    gpioE: 'Gpio E',
                    gpioF: 'Gpio F',
                    wiganInput: 'Wigan Input',
                    buzzerStatus: 'Buzzer Status',
                    languageType: 'Language Type',
                    autoReboot: 'Auto Reboot',
                    rebootTime: 'Reboot Time',
                    standbyOpen: 'Standby Open',
                    waitTime: 'Wait Time',
                    recognitionDistance: 'Recognition Distance',
                    networkRelayAddress: 'network Relay Address',
                    openInterval: 'Open Interval',
                    useShowAvatar: 'Show Avatar',
                    blackListTip: 'Black List Tip',
                    blackListOpen: 'Black List Open',
                    certificateThreshold: 'Certificate Threshold',
                    showUserName: 'Show User Name',
                    mshortExposure: 'Short Exposure',
                    mscreenBrightness: 'Screen Brightness',
                    msoundVolume: 'Volume',
                    mmaskDetect: 'Mask Detect',
                    mnoAccessWithoutMask: 'No Access Without Mask',
                    runing: 'Runing',
                    halt: 'Halt',
                    turnstile: 'Turnstile Mode',
                    accessControl: 'Access Control Mode',
                    swipingFaceOrCard: 'Swiping Face Or Card',
                    swipingFaceAndCard: 'Swiping Face And Card',
                    swipingFaceOrIdentityCard: 'Swiping Face Or Identity Card',
                    swipingFaceAndIdentityCard: 'Swiping Face And Identity Card',
                    swipingFaceAndIdentityCardReservation: 'Swiping Face And Identity Card Reservation',
                    swipingFaceOrCode: 'Swiping Face Or Code',
                    swipingFaceAndCode: 'Swiping Face And Code',
                    bluetooth: 'Bluetooth',
                    swipingface: 'Swiping Face',
                    faceOrQrCodeOrCard: 'Swiping Face Or qrcode or Card',
                    swipingIdentityCard: 'Swiping Identity Card',
                    doorbell: 'Doorbell',
                    alarm: 'Alarm',
                    musicAlarmBell: 'Music Alarm Bell',
                    strangerAlarm: 'Stranger Alarm',
                    maskAlarm: 'Mask Alarm',
                    doorSensor: 'Door Sensor',
                    exitButton: 'Exit Button',
                    fireSignal: 'Fire Signal',
                    securitySettings: 'Security Settings',
                    localRelay: 'Local Relay',
                    wigan26: 'Wigan26(8+16bit ID)',
                    wigan32: 'Wigan32',
                    wigan34: 'Wigan34',
                    networkRelay: 'Network Relay',
                    wigan26Bit24: 'Wigan26(24bit ID)',
                    simplifiedChinese: 'Simplified Chinese',
                    traditionalChinese: 'Traditional Chinese',
                    english: 'English',
                },
                zh: {
                    son: '子设备名称/子设备ID',
                    pleaseSelect: '请选择',
                    pleaseInput: '请输入',
                    none: '无',
                    in: '入',
                    out: '出',
                    open: '开启',
                    close: '关闭',
                    deviceError: '通行任务异常',
                    deviceRunType: '设备运行状态',
                    useMode: '使用模式',
                    mode: '核验模式',
                    welcomeTip: '欢迎提示',
                    verifySuccessTip: '识别成功提示',
                    verifyFaultTip: '识别失败提示',
                    showUserInfo: '展示用户信息',
                    faceWidth: '人脸宽度',
                    openDoorType: '开门方式',
                    keepDoorOpenDuration: '开门时长',
                    gpioA: 'Gpio A',
                    gpioB: 'Gpio B',
                    gpioC: 'Gpio C',
                    gpioD: 'Gpio D',
                    gpioE: 'Gpio E',
                    gpioF: 'Gpio F',
                    wiganInput: '韦根输入',
                    buzzerStatus: '蜂鸣器报警',
                    languageType: '语言',
                    autoReboot: '自动重启',
                    rebootTime: '重启时间',
                    standbyOpen: '打开待机',
                    waitTime: '待机时间',
                    recognitionDistance: '识别距离',
                    networkRelayAddress: '网络继电器IP',
                    openInterval: '再次识别间隔',
                    useShowAvatar: '显示头像',
                    blackListTip: '黑名单提示',
                    blackListOpen: '黑名单开门',
                    certificateThreshold: '认证对比阈值',
                    showUserName: '识别成功显示用户名',
                    mshortExposure: '短曝光频率',
                    mscreenBrightness: '屏幕亮度',
                    msoundVolume: '音量',
                    mmaskDetect: '口罩检测',
                    mnoAccessWithoutMask: '不戴口罩不开门',
                    runing: '运行',
                    halt: '停机',
                    turnstile: '闸机模式',
                    accessControl: '门禁模式',
                    swipingFaceOrCard: '刷脸或刷卡',
                    swipingFaceAndCard: '刷脸且刷卡',
                    swipingFaceOrIdentityCard: '刷脸或刷身份证',
                    swipingFaceAndIdentityCard: '刷脸且刷身份证',
                    swipingFaceAndIdentityCardReservation: '刷脸且刷身份证预约',
                    swipingFaceOrCode: '刷脸或扫码',
                    swipingFaceAndCode: '刷脸且扫码',
                    bluetooth: '蓝牙',
                    swipingface: '人脸',
                    faceOrQrCodeOrCard: '人脸或二维码或刷卡',
                    swipingIdentityCard: '刷卡且刷脸',
                    doorbell: '门铃',
                    alarm: '报警器',
                    musicAlarmBell: '音乐警铃',
                    strangerAlarm: '陌生人报警',
                    maskAlarm: '口罩报警',
                    doorSensor: '门磁',
                    exitButton: '出门按钮',
                    fireSignal: '消防信号',
                    securitySettings: '保全设定',
                    localRelay: '本地继电器',
                    wigan26: '韦根26(8+16bit ID)',
                    wigan32: '韦根32',
                    wigan34: '韦根34',
                    networkRelay: '网络继电器',
                    wigan26Bit24: '韦根26(24bit ID)',
                    simplifiedChinese: '简体中文',
                    traditionalChinese: '繁体中文',
                    english: '英语'
                },
            },
        },
    })
], default_1);
export default default_1;
